import { useState, useEffect, useCallback } from "react";
import { SimpleGrid, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Loading from "../Component/Loading/loading";
import apiService from "../Method/Account_Service";
import permissionService from "../Method/Permission_Service";
import { ThemeProvider } from "@mui/material/styles";
import MUIDataTable from "mui-datatables";
import theme from "../assets/Table/TableTheme";
import options from "../assets/Table/TableOption_NoPrint";
import { IconButton } from "@mui/material";
import InputText from "../Component/Input/Input";
import { EditIcon } from "@chakra-ui/icons";
import renderPermissionTile from "../Component/Permission_Card/permission_card";
import DropDown from "../Component/Dropdown/Dropdown";
import { Box, Flex, Text } from "@chakra-ui/react";
import CustomSwitch from "../Component/Permission_Card/custom_switch";
const App = () => {
  const { t } = useTranslation();

  const allPermissions = [
    "ENABLE_SALES",
    "ENABLE_RETURN_SALES",
    "ENABLE_CLIENT",
    "ENABLE_VISITOR",
    "ENABLE_ACCOUNTING",
    "ENABLE_INSERT_NOTE_FOR_CLIENT",
    "ENABLE_CLIENT_BALANCE",
    "ENABLE_PRODUCT",
    "ENABLE_REPORTING",
    "ENABLE_VIEW_DELIVERY_ORDERS",
    "ENABLE_EDIT_ORDER_AFTER_PUBLISH",
    "ENABLE_VIEW_ORDER_AFTER_ACCEPT",
    "ENABLE_VIEW_SYSTEM_ORDER",
    "ENABLE_APPLICATION_STATUS",
    "ENABLE_OFFERS",
    "ENABLE_IS_PAYMENT_NEGATIVE",
    "ENABLE_DELIVERY_AREA",
    "ENABLE_SAVE_SALES",
    "ENABLE_EDIT_SALES",
    "ENABLE_DELETE_SALES",
    "ENABLE_LOCATION_REQUIRED",
    "ENABLE_CHANGE_PRICE_TYPE",
    "ENABLE_DISCOUNT",
    "ENABLE_FREE_ITEM",
    "ENABLE_CHECK_CLIENT_PHONE",
    "ENABLE_PHONE_REQUIRED",
    "ENABLE_NOT_BRING_CLIENT_PHONE",
    "CHECK_MANDOOB_LOCATION_ON_CHANGE_INVOICE_STATUS",
    "ENABLE_ADD_CLIENT",
    "ENABLE_ALLOW_EDIT_CLIENT_BEFORE_PUBLISH",
    "ENABLE_CUSTOMER_TRANSACTIONS",
    "ENABLE_ADD_SANAD_DOLLAR",
    "ENABLE_ADD_SANAD_DINAR",
    "ENABLE_SAVE_SANAD",
    "ENABLE_EDIT_SANAD",
    "ENABLE_DELETE_SANAD",
    "ENABLE_DETAILED_MATERIAL_SALES_REPORT",
    "ENABLE_SALES_REPORT",
    "ENABLE_SALE_ITEM_BEFORE_PUBLISH",
    "ENABLE_STORE_ITEM_REPORT",
    "ENABLE_CUSTOMER_DEBIT_REPORT",
    "ENABLE_IS_OFFLINE",
    "ENABLE_APPLICATION_STATUS_OFFLINE",
    "ENABLE_APPLICATION_STATUS_ONLINE",
    "ENABLE_CHANGE_APPLICATION_STATUS",
    "ENABLE_SHOW_PREVIEW_CLIENT_BALANCE",

  ];

  const [data, setData] = useState([]);
  const [PermissionPackages, setPermissionPackages] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [form, setForm] = useState({
    ID: "",
    PIN_CODE: null,
    INVOICE_NO: null,
    EXPIRE_DATE: null,
    MAX_COUNT: null,
    PERMISSION_PACKAGE: null,
    PERMISSION_NAME: "",
  });
  const [permissions, setPermissions] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [ACTIVE, setACTIVE] = useState(false);

  const autoGeneratePinCode = () => {
    const timestamp = Date.now();
    const last6Digits = timestamp % 1000000;
    return last6Digits.toString().padStart(6, '0');
  };

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { success: successAccounts, data: dataAccounts } = await apiService.get();
      if (successAccounts) setData(dataAccounts);

      const { success: successPackages, data: dataPackages } = await permissionService.get();
      if (successPackages) setPermissionPackages(dataPackages);

      setForm((prev) => ({
        ...prev,
        PIN_CODE: autoGeneratePinCode(),
      }));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleClear = () => {
    setForm({
      ID: "",
      PIN_CODE: autoGeneratePinCode(),
      INVOICE_NO: "",
      EXPIRE_DATE: "",
      MAX_COUNT: "",
      PERMISSION_PACKAGE: null,
      PERMISSION_NAME: "",
    });
    setPermissions({});
    setACTIVE(false);
    setIsEdit(false);
    setError(null);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().slice(0, 10);
  };

  const handleEdit = (rowIndex) => {
    const row = data[rowIndex];
    setForm({
      ID: row._id,
      PIN_CODE: row.PIN_CODE,
      INVOICE_NO: row.INVOICE_NO,
      EXPIRE_DATE: formatDate(row.EXPIRE_DATE),
      MAX_COUNT: row.MAX_COUNT,
    });
    setACTIVE(row.ACTIVE);
    setPermissions(row.PERMISSION || {});
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsEdit(true);
  };

  const togglePermission = (key) => {
    setPermissions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const cleanPermission = (perm) => {
    let prepared = {};
    allPermissions.forEach((key) => {
      prepared[key] = perm[key] === true ? true : false;
    });

    const values = Object.values(prepared);
    const countTrue = values.filter((v) => v === true).length;

    if (countTrue === values.length || countTrue === 0) return {};
    return prepared;
  };




  const formatDateValue = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    return `${year}/${month}/${day}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const cleanedPermissions = cleanPermission(permissions);

    const payload = {
      _id: form._id,
      PIN_CODE: form.PIN_CODE ? Number(form.PIN_CODE) : 0,
      INVOICE_NO: form.INVOICE_NO ? Number(form.INVOICE_NO) : 0,
      EXPIRE_DATE: formatDateValue(form.EXPIRE_DATE),
      MAX_COUNT: form.MAX_COUNT ? parseInt(form.MAX_COUNT, 10) : 0,
      ACTIVE: ACTIVE,
      SUB_ACCOUNT: [],
      PERMISSION: cleanedPermissions,
    };

    const apiLink = isEdit ? "UPDATE_ACCOUNTS_BY_PIN" : "INSERT_ACCOUNT";
    if (isEdit) {
      payload._id = form.ID;
    }

    const { success, error } = await apiService.post(payload, apiLink);

    if (success) {
      fetchData();
      handleClear();
    } else {
      setError(error.response?.data);
    }
  };

  const toggleACTIVE = () => setACTIVE((prev) => !prev);
  const tableColumns = [
    { name: "_id", label: "ID", options: { filter: false, sort: false, display: false, viewColumns: false } },
    { name: "PIN_CODE", label: t("PIN_CODE"), options: { filter: false, sort: false } },
    { name: "INVOICE_NO", label: t("INVOICE_NO"), options: { filter: false, sort: false } },
    { name: "EXPIRE_DATE", label: t("EXPIRE_DATE"), options: { filter: false, sort: false } },
    { name: "MAX_COUNT", label: t("MAX_COUNT"), options: { filter: false, sort: false } },
    { name: "PERMISSION", label: t("PERMISSION"), options: { filter: false, sort: false, display: false, viewColumns: false } },
    {
      name: "ACTIVE",
      label: t("ACTIVE"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              style={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                backgroundColor: value === true ? "green" : "red",
              }}
            ></div>
          </div>
        ),
      },
    },
    {
      name: "",
      label: t("Edit"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <IconButton
            className="TableIcon"
            onClick={() => handleEdit(tableMeta.rowIndex)}
          >
            <EditIcon />
          </IconButton>
        ),
      },
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <form onSubmit={handleSubmit}>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap={5} p={5}>
          <InputText
            type="number"
            required
            value={form.PIN_CODE}
            labels={t("PIN_CODE")}
            onChange={(v) => setForm((f) => ({ ...f, PIN_CODE: v }))}
          />
          <InputText
            type="number"
            required
            value={form.INVOICE_NO}
            labels={t("INVOICE_NO")}
            onChange={(v) => setForm((f) => ({ ...f, INVOICE_NO: v }))}
          />
          <InputText
            type="date"
            required
            value={form.EXPIRE_DATE}
            labels={t("EXPIRE_DATE")}
            onChange={(v) => setForm((f) => ({ ...f, EXPIRE_DATE: v }))}
          />
          <InputText
            required
            type="number"
            value={form.MAX_COUNT}
            labels={t("MAX_COUNT")}
            onChange={(v) => setForm((f) => ({ ...f, MAX_COUNT: v }))}
          />



          <Box  >
            <SimpleGrid gap={2} columns={1} className="Permission_Content" style={{ marginInline: "5px" }}>
              <Flex justify="space-between" style={{ paddingInline: "25px" }}  >
                <Text fontSize="md">{t("ACTIVE")}</Text>
                <CustomSwitch checked={ACTIVE} onChange={toggleACTIVE} />
              </Flex>
            </SimpleGrid>
          </Box>

          <SimpleGrid columns={1} p={5}>
            <DropDown
              multiple
              data={PermissionPackages}
              placeholder={t("Select_Permission_Package")}
              optionlables={(option) => option.PERMISSION_NAME}
              value={form.PERMISSION_PACKAGE}
              onChange={(selectedList) => {
                if (Array.isArray(selectedList) && selectedList.length > 0) {
                  const combinedPermissions = selectedList.reduce((acc, pkg) => {
                    return { ...acc, ...(pkg.PERMISSION || {}) };
                  }, {});
                  setPermissions(combinedPermissions);
                  setForm((prev) => ({
                    ...prev,
                    PERMISSION_NAME: selectedList.map(p => p.PERMISSION_NAME).join(", "),
                    PERMISSION_PACKAGE: selectedList,
                  }));
                } else {
                  setPermissions({});
                  setForm((prev) => ({
                    ...prev,
                    PERMISSION_NAME: "",
                    PERMISSION_PACKAGE: [],
                  }));
                }
              }}
            />

          </SimpleGrid>


        </SimpleGrid>

        <SimpleGrid
          gap={2}
          columns={{ base: 1, md: 2, lg: 2, "2xl": 2 }}
          style={{ marginInline: "5px", marginTop: "15px" }}
        >
          {renderPermissionTile(
            "MAIN_PERMISSIONS",
            [
              "ENABLE_SALES",
              "ENABLE_RETURN_SALES",
              "ENABLE_CLIENT",
              "ENABLE_VISITOR",
              "ENABLE_ACCOUNTING",
              "ENABLE_PRODUCT",
              "ENABLE_REPORTING",
              "ENABLE_VIEW_DELIVERY_ORDERS",
              "ENABLE_EDIT_ORDER_AFTER_PUBLISH",
              "ENABLE_VIEW_ORDER_AFTER_ACCEPT",
              "ENABLE_VIEW_SYSTEM_ORDER",
              "ENABLE_APPLICATION_STATUS", "ENABLE_SHOW_PREVIEW_CLIENT_BALANCE",

            ],
            permissions,
            togglePermission
          )}

          {renderPermissionTile(
            "ENABLE_SALES",
            [
              "ENABLE_OFFERS",
              "ENABLE_IS_PAYMENT_NEGATIVE",
              "ENABLE_DELIVERY_AREA",
              "ENABLE_SAVE_SALES",
              "ENABLE_EDIT_SALES",
              "ENABLE_DELETE_SALES",
              "ENABLE_LOCATION_REQUIRED",
              "ENABLE_CHANGE_PRICE_TYPE",
              "ENABLE_DISCOUNT",
              "ENABLE_FREE_ITEM",
              "ENABLE_CHECK_CLIENT_PHONE",
              "ENABLE_PHONE_REQUIRED",
              "ENABLE_NOT_BRING_CLIENT_PHONE",
              "CHECK_MANDOOB_LOCATION_ON_CHANGE_INVOICE_STATUS",
            ],
            permissions,
            togglePermission
          )}

          <SimpleGrid gap={2} columns={1}>
            {renderPermissionTile(
              "ENABLE_CLIENT",
              [
                "ENABLE_ADD_CLIENT",
                "ENABLE_ALLOW_EDIT_CLIENT_BEFORE_PUBLISH",
                "ENABLE_CUSTOMER_TRANSACTIONS"
              ],
              permissions,
              togglePermission
            )}

            {renderPermissionTile(
              "ENABLE_ACCOUNTING",
              [
                "ENABLE_ADD_SANAD_DOLLAR",
                "ENABLE_ADD_SANAD_DINAR",
                "ENABLE_SAVE_SANAD",
                "ENABLE_EDIT_SANAD",
                "ENABLE_DELETE_SANAD",
                "ENABLE_CLIENT_BALANCE",
                "ENABLE_INSERT_NOTE_FOR_CLIENT",
              ],
              permissions,
              togglePermission
            )}
          </SimpleGrid>



          <SimpleGrid gap={2} columns={1}>
            {renderPermissionTile(
              "ENABLE_REPORTING",
              [
                "ENABLE_DETAILED_MATERIAL_SALES_REPORT",
                "ENABLE_SALES_REPORT",
                "ENABLE_SALE_ITEM_BEFORE_PUBLISH",
                "ENABLE_STORE_ITEM_REPORT",
                "ENABLE_CUSTOMER_DEBIT_REPORT",

              ],
              permissions,
              togglePermission
            )}

            {renderPermissionTile(
              "ENABLE_APPLICATION_STATUS",
              [
                "ENABLE_IS_OFFLINE",
                "ENABLE_APPLICATION_STATUS_OFFLINE",
                "ENABLE_APPLICATION_STATUS_ONLINE",
                "ENABLE_CHANGE_APPLICATION_STATUS",
              ],
              permissions,
              togglePermission
            )}
          </SimpleGrid>



        </SimpleGrid>
        <Button type="submit" className="Permission-btn" mt={"15px"} >
          {t("save")}
        </Button>
      </form>

      {error && <p className="error-message">{error}</p>}
      {isLoading && <Loading />}
      {!isLoading && (
        <div style={{ marginTop: "20px" }}>
          <MUIDataTable
            title=""
            data={data}
            columns={tableColumns}
            options={options}
          />
        </div>
      )}
    </ThemeProvider>
  );
};










export default App;

